import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fea6479"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-section" }
const _hoisted_2 = { class: "product-section__heading" }
const _hoisted_3 = { class: "product-count" }
const _hoisted_4 = { class: "product-section__options" }
const _hoisted_5 = { class: "view-options" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-apps-sqr" }, null, -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-list-sqr" }, null, -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]

import { useProductsRepo } from '@/store';
import { useProductView, ViewType } from '@/composables';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import SortOptionList from './SortOptionList.vue';
import { ProductListView } from './product-list';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsView',
  setup(__props) {


const { productsFiltered, isLoading } = storeToRefs(useProductsRepo());
const { type } = useProductView();

function toggleGrid() {
  type.value = ViewType.Grid;
}

function toggleList() {
  type.value = ViewType.List;
}

const listClass = computed(() => {
  return type.value === ViewType.List ? 'view-options__btn_active' : '';
});

const gridClass = computed(() => {
  return type.value === ViewType.Grid ? 'view-options__btn_active' : '';
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(" Products "),
      _createElementVNode("span", _hoisted_3, "found " + _toDisplayString(!_unref(isLoading) ? _unref(productsFiltered).length : '--') + " products", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(SortOptionList, { "sort-keys": ['title', 'rating', 'price', 'stock'] }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn view-options__btn", _unref(gridClass)]),
          onClick: toggleGrid
        }, _hoisted_7, 2 /* CLASS */),
        _createElementVNode("button", {
          class: _normalizeClass(["btn view-options__btn", _unref(listClass)]),
          onClick: toggleList
        }, _hoisted_9, 2 /* CLASS */)
      ])
    ]),
    _createVNode(_unref(ProductListView), { viewType: _unref(type) }, null, 8 /* PROPS */, ["viewType"])
  ]))
}
}

})